<template>
  <client-only>
    <div v-if="sessionStore.isLoggedIn" class="breadcrumb">
      <div class="item" @click="toPage('dashboard')">
        {{ $t("bnpl:breadcrumb.dashboard") }}
      </div>
      <template v-for="(item, index) in items">
        <IconsChevronRight />
        <div class="item">
          {{ item }}
        </div>
      </template>
    </div>
  </client-only>
</template>

<script setup>
import { useSelfcareStore } from "~~/stores/selfcare";
import { useSessionStore } from "~/stores/session";

const selfcareStore = useSelfcareStore();
const sessionStore = useSessionStore();

const items = computed(() => selfcareStore.breadcrumb.items);

const toPage = (page) => {
  selfcareStore.navigateTo(page);
};
</script>

<style scoped lang="scss">
.breadcrumb {
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 16px;
  color: var(--brandPrimary);
}

.item:last-child {
  font-weight: 700;
  color: var(--gray600);
}

.item:not(:last-child) {
  cursor: pointer;
}

svg {
  width: 10px;
  height: 10px;
}
</style>
